/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function FacebookIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M9,8 L6,8 L6,12 L9,12 L9,24 L14,24 L14,12 L17.642,12 L18,8 L14,8 L14,6.333 C14,5.378 14.192,5 15.115,5 L18,5 L18,0 L14.192,0 C10.596,0 9,1.583 9,4.615 L9,8 Z" />
    </SvgIcon>
  );
}
